const API_URL = import.meta.env.VITE_SIMPLE_REST_URL;

export const refreshAccessToken = async (): Promise<boolean> => {
    try {
        const refreshToken = localStorage.getItem('refreshToken');

        if (!refreshToken) {
            return false;
        }

        const response = await fetch(`${API_URL}/auth/refresh`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${refreshToken}`,
            },
        });
        
        if (!response.ok) {
            console.error('Refresh token API call failed with status:', response.status);
            // Refresh token is invalid or expired
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            return false;
        }

        // Check if response has content before parsing
        const text = await response.text();
        if (!text) {
            console.error('Empty response from refresh endpoint');
            return false;
        }

        const data = JSON.parse(text);
        
        if (data.accessToken) {
            // Store the new access token
            localStorage.setItem('accessToken', data.accessToken);
            
            // If a new refresh token is provided, update it as well
            if (data.refreshToken) {
                localStorage.setItem('refreshToken', data.refreshToken);
            }
            
            return true;
        }
        
        console.error('No access token in refresh response');
        return false;
    } catch (error) {
        console.error('Error refreshing token:', error);
        // Don't clear tokens on network errors - might be temporary
        return false;
    }
}; 